import {
	VALIDATE_EMAIL_REG_EXP,
	VALIDATE_PHONE_NUMBER_REG_EXP,
} from '@zyro-inc/site-modules/constants/regex';

import { InputValidationError } from '@zyro-inc/site-modules/types';

type ValidationType = 'required' | 'email' | 'phone' | 'maxLength' | 'minLength';

export type StringValidationOptions = {
	fieldName: string;
	validations: ValidationType[];
	validationMessages: Record<string, string>;
	maxLength?: number;
	minLength?: number;
};

const lengthIsValid = (length: number | undefined) => length !== undefined && length >= 0;

export default function validateString({
	value,
	options,
}: {
  value: string;
  options: StringValidationOptions;
}): InputValidationError[] {
	const validationErrors = [];

	if (options.validations.includes('required') && !value.replace(/ /g, '')) {
		validationErrors.push({
			message: options.validationMessages.required,
			name: options.fieldName,
		});
	}

	if (!value.replace(/ /g, '')) {
		return validationErrors;
	}

	if (options.validations.includes('email') && !VALIDATE_EMAIL_REG_EXP.test(value)) {
		validationErrors.push({
			message: options.validationMessages.email,
			name: options.fieldName,
		});
	}

	if (options.validations.includes('phone') && !VALIDATE_PHONE_NUMBER_REG_EXP.test(value)) {
		validationErrors.push({
			message: options.validationMessages.phone,
			name: options.fieldName,
		});
	}

	if (options.validations.includes('maxLength') && lengthIsValid(options.maxLength) && value.length > options.maxLength!) {
		validationErrors.push({
			message: options.validationMessages.maxLength,
			name: options.fieldName,
		});
	}

	if (options.validations.includes('minLength') && lengthIsValid(options.minLength) && value.length < options.minLength!) {
		validationErrors.push({
			message: options.validationMessages.minLength,
			name: options.fieldName,
		});
	}

	return validationErrors;
}
